var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TableWithEndlessScroll',{class:_vm.$style.osReleaseTable,attrs:{"columns":_vm.columns,"moreToLoad":false,"tableData":_vm.tableData},scopedSlots:_vm._u([{key:"emptyMessage",fn:function(){return [_c('p',[_vm._v(" Release train information is not available right now. Please try again later. ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }